import get from 'lodash/get';

const getPageType = () =>
    !__SERVER__ ? get(window, 'digitalData.page.pageInfo.pageType', '') : '';

export const isPDPPage = (pageUrl = '') => {
    return pageUrl.includes('/p/');
};

export const isCheckoutPage = (pageUrl = '') => {
    return pageUrl.includes('/checkout');
};

export default getPageType;
